import { Skeleton } from "primereact/skeleton";

const FilterListShimmer = () => {

  return (
    <>
    <div className="ui-filter-flex col-12" >
        <ul className="ui-filter-items ui-filter-flex-colls ui-filter-flex-auto shimmer-pulsate col-12 flex flex-nowrap">
          {
             [...Array(10)].map((e, i) =>
              <li key={`FilterListShiimer${i}`}  className="shimmer-pulsate dropdowns ui-filter-item multi-dropdowns flex-auto"> </li>
            )
          }
        </ul>

        <div className="ui-filter-flex-colls shimmer-pulsate">
            <a  className="button-links grey-link mt-1 pt-1 shimmer-pulsate cursor-pointer" >
              {/* More Filters */}
            </a>
          </div>
      </div>
    </>
  );
};

export default FilterListShimmer;
